/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Learn_DescriptionInputs */

const en_gc_resources_learn_description = /** @type {(inputs: Gc_Resources_Learn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short, practical GridCraft tutorials for a first workbook, a working formula and a clearer view of your data. Each guide includes an example you can try in the editor.`)
};

const zh_gc_resources_learn_description = /** @type {(inputs: Gc_Resources_Learn_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简短实用的 GridCraft 教程，覆盖首个工作簿、基础公式和数据分析。每篇指南都包含能在编辑器中尝试的示例。`)
};

/**
* | output |
* | --- |
* | "Short, practical GridCraft tutorials for a first workbook, a working formula and a clearer view of your data. Each guide includes an example you can try in t..." |
*
* @param {Gc_Resources_Learn_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_learn_description = /** @type {((inputs?: Gc_Resources_Learn_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Learn_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_learn_description(inputs)
	return zh_gc_resources_learn_description(inputs)
});
export { gc_resources_learn_description as "gc.resources.learn.description" }